import {CASHPOINTS_SUCCESS} from 'new-constants/api.constants';
import {DONE_LOGOUT_CONFIRMATION} from 'new-constants/popup.constants';
import {CashpointsState} from './cashpoints.reducer.types';

export const defaultCashpointsCacheEntry = {
	amount: 0,
	transactions: [],
};

const initialState: CashpointsState = {
	cache: {},
};

export const cashpointsReducer = (previousState = initialState, action): CashpointsState => {
	switch (action && action.type) {
		case CASHPOINTS_SUCCESS:
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.payload.data.restaurantId]: {
						amount: action.payload.data.amount,
						amountExpiration: action.payload.data.amountExpiration,
						transactions: action.payload.data.transactions,
						fetchedTimestamp: action.payload.data.fetchedTimestamp,
					},
				},
			};
			break;

		case DONE_LOGOUT_CONFIRMATION:
			return {
				...previousState,
				cache: {},
			};
			break;
	}
	return previousState;
};
